import React, {useEffect, useState} from 'react';
import {menuMaterialApi} from "../../../../apis/admin/menu/menuMaterialApi";

interface LazyAndPreloadImageProps  {
  path: string;
};

export const LazyAndPreloadImage = (props: LazyAndPreloadImageProps) => {
  const {
    path
  } = props;
  const [loaded, setLoaded] = useState<string>('');
  const readerOnloadend = async (data: any): Promise<FileReader> => {
    return new Promise((resolve, reject) => {  // eslint-disable-line
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader);
      };
      reader.readAsDataURL(data);
    });
  };

  useEffect(() => {
    // preload しておく
    // const img = new Image();

    // const reader = new FileReader();
    const fetch = async () => {
      const response = await menuMaterialApi.downloadFile(
        {
          path
        },
        {
          // abortSignal: abortController?.signal,
          responseType: 'blob',
          dataType: 'binary'
        });
      // reader.readAsDataURL(new Blob([response])
      const blob = new Blob([response]);
      const reader: FileReader = await readerOnloadend(blob);
      setLoaded(String(reader.result));
    };
    fetch();
  }, [path]);

  return  (
    <>
      {loaded &&
      <img src={loaded} alt="サムネイル" className="max-h-16 max-w-16" />
      }
    </>
  );
};